import React from 'react';
import { COLORS, RADII } from './chartTokens';

// ─────────────────────────────────────────────────────────────
// EmptyState – Generic no-data placeholder
// Props:
//   icon: emoji string
//   title: string
//   message: string
//   minHeight: string (default '320px')
// ─────────────────────────────────────────────────────────────

const EmptyState = ({
  icon = '📊',
  title = 'No Data Available',
  message = 'Select filters to view chart data.',
  minHeight = '320px',
}) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight,
    padding: '32px 24px',
    textAlign: 'center',
  }}>
    {/* Icon bubble */}
    <div style={{
      width: '80px',
      height: '80px',
      borderRadius: '50%',
      background: 'linear-gradient(135deg, #EEF2FF 0%, #F5F3FF 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '36px',
      marginBottom: '20px',
      boxShadow: '0 4px 16px rgba(99,102,241,0.12)',
    }}>
      {icon}
    </div>

    {/* Title */}
    <h4 style={{
      fontSize: '18px',
      fontWeight: '600',
      color: COLORS.text,
      marginBottom: '8px',
      fontFamily: 'Inter, system-ui, Arial, sans-serif',
    }}>
      {title}
    </h4>

    {/* Message */}
    <p style={{
      fontSize: '14px',
      color: COLORS.textMuted,
      maxWidth: '320px',
      lineHeight: '1.6',
      margin: 0,
      fontFamily: 'Inter, system-ui, Arial, sans-serif',
    }}>
      {message}
    </p>
  </div>
);

export default EmptyState;
